import { FC, useContext } from "react";

import {
  Analytics,
  Assignment,
  Favorite,
  Feedback as FeedbackIcon,
  Settings,
} from "@mui/icons-material";
import {
  IconButton,
  Theme,
  Tooltip,
  useMediaQuery,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

import { AuthStateContext } from "@/contexts/AuthContext";
import { useSidebar } from "@/contexts/SidebarContext";

import { collapsedAppIconSx } from "./collapsedAppIconSx";
import { frameNavItemSx } from "./frameNavItemSx";

interface Props {
  dense?: boolean;
  logout?: () => void;
  onMenuClick?: () => void;
  collapsed?: boolean;
}

const RubiFeedbackMenu: FC<Props> = ({ dense = false, collapsed = false }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery((theme as Theme).breakpoints.down("sm"));
  const { setCollapsed } = useSidebar();
  const { currentUser, getOrgIDFromURL } = useContext(AuthStateContext);
  const orgID = getOrgIDFromURL() ?? currentUser?.rubi_org_id ?? "";

  const hideSideBar = () => {
    setCollapsed(true);
  };

  const menuItems = [
    {
      to: `/rubifeedback/${orgID}/feedback`,
      text: "Feedback",
      icon: <Favorite />,
    },
    {
      to: `/rubifeedback/${orgID}/surveys`,
      text: "Surveys",
      icon: <Assignment />,
    },
    {
      to: `/rubifeedback/${orgID}/dashboard`,
      text: "Dashboard",
      icon: <Analytics />,
    },
    {
      to: `/rubifeedback/${orgID}/settings`,
      text: "Settings",
      icon: <Settings />,
    },
  ];

  return (
    <div className="menu">
      {!collapsed ? (
        <div className="sidebar-top">
          <div className="app-name">
            Rubi<span>FEEDBACK</span>
          </div>
        </div>
      ) : (
        <div className="application-item">
          <Tooltip title="Community Feedback" placement="right" arrow>
            <IconButton
              aria-label="RubiFEEDBACK App"
              size="large"
              disableRipple
              sx={collapsedAppIconSx}
            >
              <FeedbackIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
      <div className="left-menu">
        {menuItems.map((item) => (
          <Tooltip
            key={item.to}
            title={collapsed ? item.text : ""}
            placement="right"
            arrow
          >
            <MenuItem
              component={NavLink}
              to={item.to}
              onClick={isSmall ? hideSideBar : undefined}
              sx={[
                frameNavItemSx(),
                {
                  pl: collapsed ? 1 : 2,
                  py: dense ? 1 : 1.5,
                  minHeight: collapsed ? 48 : "auto",
                  justifyContent: collapsed ? "center" : "flex-start",
                },
              ]}
            >
              <ListItemIcon
                sx={{
                  minWidth: collapsed ? 0 : 40,
                  mr: collapsed ? 0 : 2,
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              {!collapsed && <ListItemText primary={item.text} />}
            </MenuItem>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export default RubiFeedbackMenu;
